import { Link, useParams } from 'react-router-dom'

import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar'
import { cn } from '@/lib/utils'

/** 用户 / bot 列表；点击进入同级 `:id` 详情 */
const UserList = ({ users, emptyText = '暂无数据' }) => {
  if (users && users.length === 0) {
    return <p className="p-4 text-sm text-muted-foreground">{emptyText}</p>
  }
  return (
    <div className="space-y-1">
      {users?.map((user) => (
        <UserItem key={user.id} user={user} />
      ))}
    </div>
  )
}

const UserItem = ({ user }) => {
  const { id } = useParams()
  const isBot = user.kind === 'bot'

  return (
    <Link to={user.id}>
      <div
        className={cn(
          'flex items-center gap-4 p-3 hover:bg-muted hover:rounded-md',
          user.id === id && 'bg-muted rounded-md text-primary',
        )}
      >
        <Avatar className="hidden h-9 w-9 sm:flex">
          <AvatarImage src={user.avatarThumb} alt="Avatar" />
          <AvatarFallback>{isBot ? 'BOT' : 'OM'}</AvatarFallback>
        </Avatar>
        <div className="grid gap-1">
          <p className="text-sm font-medium leading-none">{user.name}</p>
          <p className="text-sm text-muted-foreground">{user.id}</p>
        </div>
      </div>
    </Link>
  )
}

export default UserList
